import RootState from './RootState';
import {
  Module,
  ActionTree,
  ActionContext,
  GetterTree,
  MutationTree,
} from 'vuex';

export interface AppState {
  showNavigationBar: boolean;
}

export const state: AppState = {
  // tslint:disable-next-line: triple-equals
  showNavigationBar: localStorage.getItem('asea.user.showNav') === 'true',
};

export const actions: ActionTree<AppState, RootState> = {
  toggleNavigationBar(context: ActionContext<AppState, RootState>) {
    context.commit('setShowNavigationBar');
  },
};

export const getters: GetterTree<AppState, RootState> = {
  showNavigationBar(state: AppState): Boolean {
    return state.showNavigationBar;
  },
};

export const mutations: MutationTree<AppState> = {
  setShowNavigationBar(state: AppState) {
    state.showNavigationBar = !state.showNavigationBar;
  },
};

export const app: Module<AppState, RootState> = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
